var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"ui-breadcrumbs breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_vm._l((_vm.items),function(ref){
var route = ref.route;
var name = ref.name;
var active = ref.active;
return [(route)?_c('router-link',{attrs:{"tag":"li","to":route,"exact":""}},[_c('a',[_vm._v(_vm._s(name))])]):_c('li',{class:{"is-active":active}},[_c('a',[_vm._v(_vm._s(name))])])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }